<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search 
                                            :search="sorting"
                                            @searchdata="getPartner()">
                                        </vue-search>
                                    </div>

                                    <div class="tabel-action float-right">
                                        <button type="submit" v-b-modal.modal-Partner class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Partner</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Logo</th>
                                                <th>Partner Name</th>
                                                <th>Phone</th>
                                                <th>Email</th>
                                                <th>Total Event</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in partner.data" :key="data.id" v-on:click="editPartner(data)">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_partner" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <img v-if="data.photo" class="mr-3 img-thum-product" :src="data.photo">
                                                    <img v-if="!data.photo" class="mr-3 img-thum-product" src="https://via.placeholder.com/150">
                                                </td>
                                                <td>{{data.name}}</td>
                                                <td>{{data.phone}}</td>
                                                <td>{{data.email}}</td>
                                                <td>
                                                    <label class="badge badge-info">{{data.events_count}} Event</label>
                                                </td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="partner.total === 0" class="text-center no-data">Partner data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="partner"
                                                :sorting="sorting"
                                                @paginate="getPartner()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Partner Data Still Empty</h2>
                                    <p>On this page you can create partner</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Partner class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Partner</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_partner.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_partner = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_partner.length}}</span> partner selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeletePartner()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_partner="del_partner" @getPartner="_getPartner(),del_partner = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import ModalForm from '../partner/ModalForm.vue'
    import moment from 'moment'


    export default {
        name: "Partner",
        components: {
            VuePagination,
            VueSearch,
            ModalForm
        },
        data(){
            return {
                del_partner:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getPartner()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed:{
            ...mapState('PartnerControl', {
                partner: state => state.partner,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.partner.data ? this.del_partner.length == this.partner.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.partner.data.forEach(function (partner) {
                            if(partner.id !== 1){
                                selected.push(partner.id);
                            }
                        });
                    }
                    this.del_partner = selected;
                }
            }
        },
        methods: {
            ...mapActions('PartnerControl', ['getPartner','deletePartner']),
            ...mapMutations('PartnerControl', ['CLEAR_PARTNER','ASSIGN_FORM']),
            
            _getPartner:function(){
                this.getPartner().then(() => {
                    if(this.partner.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            editPartner:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Partner')
            },
            alertDeletePartner:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this theme data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deletePartner(this.del_partner).then(
                            this.$toast.success('Successfully Deleting Partner'),
                            this.del_partner = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_PARTNER()
        }
    };

</script>
